import React from "react";
import { styled } from "../stitches.config";
import { AnyBlock, LinkBlock as LinkBlockType } from "../types";
import { Bezel } from "./CssBlock";

// No new link blocks will be created but there might be old ones to render
export function LinkBlock({
  block,
}: {
  block: LinkBlockType;
  updateBlock: (block: AnyBlock) => void;
}) {
  return (
    <Bezel>
      <Link target="_blank" href={block.value ?? ""}>
        {block.value}
      </Link>
    </Bezel>
  );
}

const Link = styled("a", {
  wordBreak: "break-all",
  fontSize: "$5",
});
